export default {
  header: {
    home: "Home",
    product: "Product",
    about: "About",
    blog: "Blog",
    contact: "Contacts",
    contactUs: "CONTACT US",
    buyOnline: "Buy Online"
  },
  hero: {
    subtitle: "Find cars for sale and for rent near you.",
    title: "A Vehicle For Every Lifestyle Today",
    cta: "READ MORE"
  },
  company: {
    title: "Company's Profile",
    description: "Zhongce Rubber Group is committed to creating value for society, innovating science and technology, pursuing the production of safe, green and valuable tires, and bringing more products and services to consumers around the world.",
    description2: "In addition, Zhongce Rubber Group actively participates in sustainable corporate social responsibility projects and carries out humanistic and caring public welfare activities on a global scale",
    cta: "Read More"
  },
  stats: {
    foundedYear: "1958",
    foundedDesc: "Zhongce rubber predecessor was established",
    revolutionYear: "2004",
    revolutionDesc: "Bull Tire was born",
    pioneersTitle: "Pioneer",
    pioneersDesc: "Automotive aftermarket industry digital upgrade pioneer",
    standardTitle: "Benchmark",
    standardDesc: "New benchmark for passenger car tire replacement market services"
  },
  products: {
    title: "Choose Your Suitable Tire",
    popular: "POPULAR TIRE",
    subtitle: "Quarter high-end tires",
    description: "The Introduction Copy Of The Product Can Be Simply Described, About 2 To 3 Lines Of Text Can Be. The Introduction Copy Of The Product Can Be Simply Described, About 2 To 3 Lines Of Text Can Be",
    price: "$120",
    buyNow: "Read More",
    series: {
      all: "All"
    }
  },
  media: {
    title: "Media center",
    date: "2025-01-14",
    description: "We present popular cars that are rented by customers to maximize your comfort on long trips.",
    article1: {
      title: "Z7, a new generation of high-performance comfort tires",
      description: "A new generation of high-performance comfort tires released by Zhongce Rubber in 2024. On December 25, 2024, under the witness of nearly 1,000 tire dealer representatives, Zhongce Rubber Group launched a new product: a new generation of high-performance comfort tire Z7. Z7, based on the development of Zhongce rubber passenger tire Tianji tire system, breaking through tradition, bold innovation, comfort, braking, road sense, wear-resistant comprehensive upgrade, is the integration of Zhongce rubber technology innovation, known by the industry as a new generation of domestic god tire"
    },
    article2: {
      title: "Z7, a new generation of high-performance comfort tires",
      description: "A new generation of high-performance comfort tires released by Zhongce Rubber in 2024. On December 25, 2024, under the witness of nearly 1,000 tire dealer representatives, Zhongce Rubber Group launched a new product: a new generation of high-performance comfort tire Z7. Z7, based on the development of Zhongce rubber passenger tire Tianji tire system, breaking through tradition, bold innovation, comfort, braking, road sense, wear-resistant comprehensive upgrade, is the integration of Zhongce rubber technology innovation, known by the industry as a new generation of domestic god tire"
    },
    article3: {
      title: "Z7, a new generation of high-performance comfort tires",
      description: "A new generation of high-performance comfort tires released by Zhongce Rubber in 2024. On December 25, 2024, under the witness of nearly 1,000 tire dealer representatives, Zhongce Rubber Group launched a new product: a new generation of high-performance comfort tire Z7. Z7, based on the development of Zhongce rubber passenger tire Tianji tire system, breaking through tradition, bold innovation, comfort, braking, road sense, wear-resistant comprehensive upgrade, is the integration of Zhongce rubber technology innovation, known by the industry as a new generation of domestic god tire"
    },
    readMore: "Read More"
  },
  partners: {
    title: "Business partner",
    description: "We present popular cars that are rented by customers to maximize your comfort on long trips."
  },
  footer: {
    title: "Help Center",
    product: "Product Center",
    productTitle: "Product",
    aboutTitle: "About Us",
    about: "About Pilotent",
    blog: "Blog",
    contact: "Contact",
    qrcode: "Two-Dimensional code",
    wechat: "WeChat",
    tiktok: "TikTok",
    description: "We are a well-known car rental service that has many partners in each region to connect with you to assist in your trip in meetings, events, holidays or long trips.",
    copyright: "©2024 Copyright China Ce Rubber Group Co., LTD. | Zhejiang ICP No. 11018622-1 | Zhejiang Public Network Anbei 33011802000703"
  },
  common: {
    learnMore: 'Learn More',
    loading: 'Loading...',
    loadingProducts: 'Loading product information...',
    loadingMedia: 'Loading media information...',
    retry: 'Retry',
    noProducts: "No product",
    noProductData: 'No product data',
    noProductId: 'No product ID specified',
    getProductDetailFailed: 'Failed to get product details, please try again later',
    noProductDescription: 'No product description',
    buyNow: 'Buy Now',
    noMedia: 'No media information',
    collapse: 'Collapse',
    viewMore: 'View More',
    lastPage: 'Last Page',
    backToList: 'Back to List',
    getArticleDetailFailed: 'Failed to get article details, please try again later',
    empty: "No content",
    noQrcode: "No QR code"
  },
  home: {
    brandIntroTitle: "Brand Introduction",
    brandIntroText: "Bull Tire, a brand under Zhongce Rubber Group Co., Ltd., was born in 2004. Based on the broader needs of Chinese consumers and backed by Zhongce's patented technology and R&D strength, it is committed to creating long mileage, high stability, and high safety tires more suitable for Chinese road conditions and car owners, so that every car owner can enjoy a safe and comfortable driving experience.",
    groupIntroTitle: "Group Introduction",
    groupIntroText1: "Zhongce Rubber Group is committed to creating value for society, innovating science and technology, and pursuing the production of safe, green, and valuable tires, bringing more products and service choices to consumers around the world.",
    groupIntroText2: "In addition, Zhongce Rubber Group actively participates in sustainable corporate social responsibility projects and carries out humanistic and caring public welfare activities on a global scale."
  },
  about: {
    pageTitle: 'Brand Introduction',
    brandIntroTitle: 'Brand Introduction',
    brandIntroText: "Bull Tire, a brand under Zhongce Rubber Group Co., Ltd., was born in 2004. Based on the broader needs of Chinese consumers and backed by Zhongce's patented technology and R&D strength, it is committed to creating long mileage, high stability, and high safety tires more suitable for Chinese road conditions and car owners, so that every car owner can enjoy a safe and comfortable driving experience.",
    groupIntroTitle: 'Group Introduction',
    groupIntroText1: 'Zhongce Rubber Group is committed to creating value for society, innovating science and technology, and pursuing the production of safe, green, and valuable tires, bringing more products and service choices to consumers around the world.',
    groupIntroText2: 'In addition, Zhongce Rubber Group actively participates in sustainable corporate social responsibility projects and carries out humanistic and caring public welfare activities on a global scale.',
    partnersTitle: 'Partners',
    achievementsTitle: 'Brand Achievements',
    governmentAwardsTitle: 'Government Awards',
    manufacturerAwardsTitle: 'Main Manufacturer Awards',
    governmentAwards: {
      0: '2016 Zhejiang Provincial Industrial Award Gold Award',
      1: '2016 Hangzhou 12th Five-Year Tax Top 100 Enterprises',
      2: '2016 China Standard Innovation Contribution Award',
      3: '2016 China Top 500 Foreign Trade Enterprises',
      4: '2017 China Tire Enterprise Ranking No.1',
      5: '2020 Hangzhou First Batch of Kunpeng Enterprises'
    },
    manufacturerAwards: {
      0: '2014 Changan Automobile Excellent Supplier Award',
      1: '2015 Beiqi Foton Excellent Supplier Award',
      2: '2015 Guangxi Liugong Excellent Supplier Award',
      3: '2015 JAC Excellent Supplier Award',
      4: '2015 SAIC-GM Excellent Green Supplier Award',
      5: '2016 Chery Jaguar Land Rover X260L Best Production Award',
      6: '2017 JAC Excellent Supplier Award',
      7: '2017 Shaanxi Heavy Truck Excellent Supplier Award',
      8: '2017 FAW Jiefang Excellent Supplier Award'
    }
  },
  blog: {
    pageTitle: 'Media Center',
    lastPage: 'Last Page',
    learnMore: 'Learn More'
  }
} 